<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
          <i class="fa fa-truck" />
          <strong>
            {{ title }}
            <b-spinner v-if="loading" class="float-right" small />
          </strong>
        </div>
        <div>
          <create-content :form="form" ref="create-content" />
          <b-button
            variant="primary"
            :disabled="form.detailedSupplies.length == 0 || loading == true"
            class="float-right"
            @click="onSubmit"
          >
            <span class="mr-1">Guardar</span>
            <b-spinner
              v-if="loading"
              variant="light"
              class="float-right"
              small
            />
          </b-button>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import createContent from "./CreateContent.vue";
import { mapState, mapGetters } from "vuex";

export default {
  name: "MainFormPurchaseOrder",
  components: {
    createContent
  },
  data() {
    return {
      title: "Ingreso",
      loading: false,
      form: {
        company: {
          company_name: null,
          text: null,
          address1: null,
          address2: null,
          phone: null
        },
        number: null,
        order_date: null,
        delivery_date: null,
        observation: null,
        detailedSupplies: []
      }
    };
  },
  destroyed() {},
  computed: {},
  methods: {
    savePurchaseOrder() {
      const thisV = this;
      thisV.loading = true;

      this.$swal
        .fire({
          title: "Seguro que quieres guardar?",
          text: "",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "No",
          confirmButtonText: "SI"
        })
        .then(result => {
          if (result.value) {
            this.$axios({
              method: "POST",
              url: "/api/supplies/purchase-order/save_purchase_order/",
              data: this.form
            })
              .then(res => {
                if (res.data.status == 2) {
                  this.$swal.fire(
                    `El numero de compra ${this.form.number} ya existe`,
                    "",
                    "info"
                  );

                  thisV.loading = false;
                }

                if (res.data.status == 1) {
                  this.$router.push("/orden-de-compra/lista-orden-compra");

                  this.$swal.fire(
                    `Orden de compra #${this.form.number} creada con éxito`,
                    "",
                    "success"
                  );

                  thisV.loading = false;
                }
              })
              .catch(error => {
                this.$swal.fire(
                  `Problemas al realizar la operación`,
                  "",
                  "error"
                );

                thisV.loading = false;
              });
          } else {
            thisV.loading = false;
          }
        });
    },
    onSubmit() {
      this.savePurchaseOrder();
    }
  }
};
</script>

<style scoped></style>
